import { pauseAllPdpMedia, qsRequired } from '../core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class DeferredMedia extends UcoastEl {
	static htmlSelector = 'deferred-media'
	constructor() {
		super()
		const poster = this.querySelector('[id^="Deferred-Poster-"]')
		if (!poster) return
		poster.addEventListener('click', this.loadContent.bind(this))
	}

	loadContent(focus = true) {
		pauseAllPdpMedia()
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			const elToAppend = qsRequired<HTMLTemplateElement>(
				'template',
				this
			).content?.firstElementChild?.cloneNode(true)

			if (elToAppend) {
				content.appendChild(elToAppend)
			}

			this.setAttribute('loaded', 'true')
			const deferredElement = this.appendChild(
				qsRequired('video, iframe', content)
			)
			if (focus) deferredElement.focus()
		}
	}
}
